import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { RecordOfCompletionDTO } from 'src/app/models/record-of-completion.model';
import { environment } from 'src/environments/environment';
import { CertificationServiceInterface } from './certification.service.interface';
import { TPWorker } from 'src/app/models/worker.model';
import { RecordOfCompletionSubmitDateDTO } from 'src/app/models/record-of-completion-submit-date.model';

@Injectable({
  providedIn: 'root'
})
export class CertificationService implements CertificationServiceInterface {

  constructor(private httpClient: HttpClient) { }
  GetRecordsOfCompletion(workerId: string): Observable<RecordOfCompletionDTO[]> {
    //Todo: Remove worker id once login works
    return this.httpClient.get<any[]>(environment.apiBaseUrl + `Worker/GetRecordsOfCompletionForWorker/${workerId}`);
  }

  GetWorkerForCertifications(workerId: string): Observable<TPWorker> { 
    return this.httpClient.get<any>(environment.apiBaseUrl + `Worker/GetWorkerDetailsForLoggedInWorker`);
  }

  GetRecordsOfCompletionSubmittedOnDate(workerId: string): Observable<RecordOfCompletionSubmitDateDTO[]> {
    return this.httpClient.get<any[]>(environment.apiBaseUrl + `Worker/GetRecordsOfCompletionDateForWorker`);
  }

}
